import { render, staticRenderFns } from "./periodic-wizard-generated-invoices.vue?vue&type=template&id=60934c0f&"
import script from "./periodic-wizard-generated-invoices.vue?vue&type=script&lang=js&"
export * from "./periodic-wizard-generated-invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports